const HandleLogout = () => {
  localStorage.clear();
  sessionStorage.removeItem("policy-accepted");
  window.location.replace("/login");
};

export default HandleLogout;